import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { AvailabilityActions } from "src/redux/Availability/actions";
import Actions from "../../Transactions/Create/Preview/Actions";
import Table from "./Table";
import { VIEWS } from "src/redux/TopBar/constants";

import styles from "./styles.module.scss";
import { AvailabilitySelectors } from "src/redux/Availability/selectors";
import { LOAN_TYPES } from "src/redux/Tx/constants";
import { ModalActions } from "src/redux/Modal/actions";
import AgentLenderNotice from "../AgentLenderNotice";

export default (props) => {
    const dispatch = useDispatch();
    const requestRows = useSelector(AvailabilitySelectors.GetRequestRows);
    const pastedNeeds = useSelector(AvailabilitySelectors.GetPastedNeeds);

    const sendTake = () => {
        // Suspend refresh during http request
        // Chrome won't allow custom message
        window.onbeforeunload = () =>
            "Are you sure you want to refresh? On-going request will be canceled or finished abnormally";

        dispatch(AvailabilityActions.SendTake(props.openAdvertise)).then(() => {
            // reset refresh suspension
            window.onbeforeunload = undefined;
        });
    };

    const handleSend = () => {
        const isSendingAfterSearch = pastedNeeds.length > 0;

        if (
            isSendingAfterSearch &&
            requestRows.some((r) => r.LoanType === LOAN_TYPES.BID)
        ) {
            dispatch(
                ModalActions.Open(AgentLenderNotice, {
                    title: "Notice",
                    width: 750,
                    height: 560,
                    customProps: {
                        onYes: sendTake,
                        onNo: () => dispatch(ModalActions.Close()),
                    },
                })
            );
        } else {
            sendTake();
        }
    };

    return (
        <div className={styles.txPreview}>
            <Table />
            <Actions
                handleSend={handleSend}
                onCancel={props.onCancel}
                type={VIEWS.AVAILABILITY}
            />
        </div>
    );
};
